import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-asahi-navbar',
  templateUrl: './asahi-navbar.component.html',
  styleUrl: './asahi-navbar.component.scss',
  imports: [CommonModule,RouterModule,TranslatePipe]

})
export class AsahiNavbarComponent {menuOpen = false;
  activeSubmenu: string | null = null;
  lang!: string;
  constructor(public router: Router, public route: ActivatedRoute) {}
  ngOnInit() {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const possibleLang = pathSegments[0];
    const supportedLangs = ['en', 'vi'];
    this.lang = supportedLangs.includes(possibleLang) ? possibleLang : 'en';
  }

  /** ✅ Toggle mobile menu */
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    this.activeSubmenu = null; 
  }

  /** ✅ Toggle submenu dropdowns */
  toggleSubmenu(menu: string) {
    this.activeSubmenu = this.activeSubmenu === menu ? null : menu;
  }

  /** ✅ Handle navigation correctly */
  onNav(path: string) {
    this.menuOpen = false; 
    this.activeSubmenu = null;
    const fullUrl =
      this.lang === 'vi'
        ? `https://www.livwell.vn/${this.lang}/${path}`
        : `https://www.livwell.vn/${path}`;
    window.location.href = fullUrl;
  }

}